import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
export function RuiIconChevronRight({
  class: className,
  size = "sm",
  ...props
}) {
  return /* @__PURE__ */jsx("svg", {
    ...props,
    class: cx("rui-icon", size === "md" && "rui-icon--md", className),
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true",
    children: /* @__PURE__ */jsx("path", {
      d: "m9 18 6-6-6-6"
    })
  });
}